import Swiper from 'swiper';

var swiper = new Swiper('.leora-carers-slider', {
  slidesPerView: 3,
  spaceBetween: 30,
  navigation: {
    nextEl: '.lc-slider-button-next',
    prevEl: '.lc-slider-button-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 3,
    },
    1440: {
      spaceBetween: 40,
    }
  },
});
